/**
 * 未登录处理器(401)
 */
export interface UnauthenticatedHandler {
    handle(error: Error): void;
}

export const UnauthenticatedHandler = Symbol('UnauthenticatedHandler');
